import DropdownIcon from "~icons/local/dropdown";
import Dropdown from "@/lib/Dropdown";
import List, { Column } from "@/lib/List";
import Menu from "@/lib/Menu";
import useModal from "@/lib/modal/useModal";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Edit from "./Edit";
import type { components } from "@/lib/ApiSchema";
import { useDeleteOrganization } from "@/lib/queries/hooks";
import toast from "react-hot-toast";

dayjs.extend(relativeTime);

export default function OrganizationList({
  data,
  isLoading,
  nonDefaultFilters,
}: {
  data: components["schemas"]["OrganizationListItemSchema"][];
  isLoading: boolean;
  nonDefaultFilters: boolean;
}) {
  const { showModal, closeModal } = useModal();
  const deleteOrganization = useDeleteOrganization();

  return (
    <List<components["schemas"]["OrganizationListItemSchema"]>
      columns={[...columns, { content: menu, className: "w-16" }]}
      list={data}
      isLoading={isLoading}
      emptyState={
        <div className="text-center text-gray-500 py-8">
          No customers found{nonDefaultFilters ? "." : " yet."}
          {nonDefaultFilters && " Try changing the filters or search criteria."}
        </div>
      }
    />
  );

  function menu(row: components["schemas"]["OrganizationListItemSchema"]) {
    return (
      <div>
        <Dropdown
          trigger={
            <DropdownIcon className="px-2 py-1 rounded-md hover:bg-gray-300 size-8" />
          }
          placement="bottom-end"
        >
          <Menu
            itemGroups={[
              [
                {
                  label: "Edit",
                  click: () => {
                    showModal(
                      <Edit organization={{ ...row }} done={closeModal} />,
                    );
                  },
                },
                {
                  label: "Delete",
                  className: "text-red-700 hover:bg-red-50",
                  click: () =>
                    deleteOrganization(
                      { id: row.id },
                      {
                        onSuccess: () => toast.success("Customer deleted"),
                      },
                    ),
                },
              ],
            ]}
          />
        </Dropdown>
      </div>
    );
  }
}

const columns: Column<components["schemas"]["OrganizationListItemSchema"]>[] = [
  { label: "Name", content: ({ name }) => name, className: "!py-4" },
  {
    label: "Domain",
    content: ({ email_domain }) => email_domain,
  },
  {
    label: "# of RFQs",
    content: ({ rfq_count }) => rfq_count,
  },
  {
    label: "Last RFQ",
    content: ({ last_rfq_created_at }) => (
      <div title={last_rfq_created_at?.toString()}>
        {last_rfq_created_at ? dayjs(last_rfq_created_at).fromNow() : "—"}
      </div>
    ),
  },
  {
    label: "Open RFQs",
    content: ({ open_rfq_count }) => open_rfq_count,
  },
  {
    label: "# of Contacts",
    content: ({ contacts_count }) => contacts_count,
  },
];
